<template>
    <div>
        <!-- 机库点组件 -->
        <EmergencyHives ref="emergencyHives" :hives="mapHives" :statiMapHives="statiMapHives" :caseListAll="caseListAll"
            :dangerCoordinate="dangerCoordinate" @changeStatiMapHives="changeStatiMapHives"
            :defaultCheckList="defaultCheckList" />

        <!-- 人员班组组件 -->
        <EmergencyPersonnel ref="emergencyPersonnel" v-bind="{
            userList,
            config: personnelConfig
        }" @update:showCloseBtn="showCloseBtn = $event" @update:userCheckList="userCheckList = $event" />

        <!-- 案件危险源组件 -->
        <EmergencyDanger ref="emergencyDanger" v-bind="{
            caseListAll, dangerObj, dangerCoordinate, userCheckList, highRises, noFlyZone, heightLimitZone,
            config: dangerConfig
        }" @update:dangerCoordinate="dangerCoordinate = $event" @update:dangerObj="dangerObj = $event"
            @update:selectDistance="selectDistance = $event" @sendCommand="handleSendCommand"
            @DeleteDataEvent="handleDeleteDataEvent" />

        <!-- 地图绘画组件 -->
        <EmergencyCanvas :caseCanvasList="caseCanvasList" @bindCaseList="getCaseList">
        </EmergencyCanvas>

        <!-- 距离选择组件 -->
        <div class="select-distance" v-show="dangerObj">
            <div class="select-distance-item" :class="{ active: item === selectDistance }"
                v-for="(item, index) in selectDistanceList" :key="index" @click.stop="selectDistanceFn(item)">
                {{ item }}
            </div>
        </div>

        <!-- 一键下发任务按钮 -->
        <div class="command-btn" v-show="dangerObj && dangerObj.status < 2" @click.stop="handleSendCommand">
            <span class="el-icon-circle-close"
                style="top: -30px; left: 70px; position: absolute; font-size: 25px; color: #fff"
                @click.stop="showRoute(null)"></span>
            {{ $t('yingji.oneClickDispatch') }}
        </div>

        <!-- 根据几何类型动态渲染对应的绘制组件 -->
        <DrawPolygon v-if="geometryType === 'Polygon'" :selectLDrawType="innerCommandType" :drawInfoList="drawInfoList"
            @addDataEvent="handleAddDataEvent" @getDrawInfoListInToday="getDrawInfoListInToday" />
        <DrawPoint v-else-if="geometryType === 'Point'" :selectLDrawType="innerCommandType" :drawInfoList="drawInfoList"
            @addDataEvent="handleAddDataEvent" @getDrawInfoListInToday="getDrawInfoListInToday" />
        <DrawLineString v-else-if="geometryType === 'LineString'" :selectLDrawType="innerCommandType"
            :drawInfoList="drawInfoList" @addDataEvent="handleAddDataEvent"
            @getDrawInfoListInToday="getDrawInfoListInToday" />

        <!-- 地面摄像头图层 -->
        <OlPointVideo :points="cameraList" :keyVideo="'cameraList'" />

        <!-- 新增案件弹窗 -->
        <AddCaseDialog :visible.sync="addCaseDialogVisible" :pendingAddCaseParams="pendingAddCaseParams"
            @confirm="handleConfirmAddCase" @cancel="handleCancelAddCase" />
    </div>
</template>

<script>
import { DoubleClickZoom, MouseWheelZoom, PinchZoom, DragPan } from 'ol/interaction';
import { tool } from '@CesiumCommon';
import { mapGetters } from 'vuex';
import { OMapMixin } from '@OpenLayersCommon';
import EmergencyHives from './EmergencyHives.vue';
import EmergencyPersonnel from './EmergencyPersonnel.vue';
import EmergencyDanger from './EmergencyCase.vue';
import EmergencyCanvas from './EmergencyCanvas.vue';
import DrawPolygon from './ol-point/drawPolygon.vue';
import DrawPoint from './ol-point/drawPoint.vue';
import DrawLineString from './ol-point/drawLineString.vue';
import OlPointVideo from './ol-point/ol-point-video.vue';
import AddCaseDialog from './caseComponents/AddCaseDialog.vue';
import { getDistance, getPointsCenter, heightJudge, getRouteDistance, getEstimateTime } from './utils/geoUtils';
import Utils from '../../../../../modules/common/OpenLayersCommon/src/util.js';
import IndexApi from '@/page/business/yingji/api/index.js';

export default {
    mixins: [OMapMixin],
    components: {
        // 基础地图组件
        // LVector,
        // OlPointCommand,
        // OlDrawHandle,

        // 业务组件
        EmergencyHives,
        EmergencyPersonnel,
        EmergencyDanger,
        EmergencyCanvas,

        // 绘制组件
        DrawPolygon,
        DrawPoint,
        DrawLineString,

        // 新增案件弹窗
        AddCaseDialog,

        // 地面摄像头
        OlPointVideo,
    },
    props: {
        // 绘制类型
        commandType: {
            type: String,
            default: '',
        },
        // 当前选中的应急案件
        activityCase: {
            type: Object,
            default: () => { },
        },
        // 案件画布（燃烧点，警戒线）列表
        caseCanvasList: {
            type: Array,
            default: () => [],
        },
        // 案件列表
        allCeseList: {
            type: Array,
            default: () => [],
        },
        // 应急班组列表
        userList: {
            type: Array,
            default: () => [],
        },
        // 地面摄像头列表
        cameraList: {
            type: Array,
            default: () => [],
        },
        // 其他业务参数
        highRises: {
            type: Array,
            default: () => [],
        },
        noFlyZone: {
            type: Array,
            default: () => [],
        },
        heightLimitZone: {
            type: Array,
            default: () => [],
        },
        initUserList: {
            type: Function,
            default: () => { },
        },
        initUserListArr: {
            type: Array,
            default: () => [],
        },
        gridId: { // 补充缺失的gridId prop
            type: String,
            default: '',
        },
    },
    emits: [
        'update:dangerObj',
        'resetEmergencyFlyType',
    ],
    computed: {
        ...mapGetters(['userInfo']),
        // 关键修复：使用computed替代data，实时获取Vuex状态
        layerAuto () {
            // 增加容错处理，避免状态未加载时出错
            return this.$store.state.Common?.LayerAuto || {};
        },

        // 计算当前绘制类型对应的几何类型
        geometryType () {
            switch (this.innerCommandType) {
                case 'warningLine-1':
                case 'warningLine-2':
                case 'warningLine-3':
                case 'intercept':
                case 'Traffic-polygon':
                case 'Traffic-square':
                case 'suspicion-square':
                case 'suspicion-polygon':
                    return 'Polygon';
                case 'dangerPoint':
                case 'firePoint':
                case 'Traffic-start':
                case 'Traffic-end':
                case 'Traffic-kakou':
                case 'suspicion-user':
                    return 'Point';
                case 'wind':
                case 'Traffic-road':
                    return 'LineString';
                default:
                    return null;
            }
        },

        // 人员组件的 config（computed 缓存引用，避免每次渲染创建新对象触发子组件 watcher）
        personnelConfig () {
            return {
                dangerObj: this.dangerObj,
                dangerCoordinate: this.dangerCoordinate,
                layerAuto: this.layerAuto,
                statiMapHives: this.statiMapHives,
                selectDistance: this.selectDistance,
                defaultCheckList: this.defaultCheckList,
                changeUserList: this.changeUserList,
                changeStatiMapHives: this.changeStatiMapHives,
                initUserList: this.initUserList,
            };
        },

        // 案件危险源组件的 config
        dangerConfig () {
            return {
                layerAuto: this.layerAuto,
                statiMapHives: this.statiMapHives,
                selectDistance: this.selectDistance,
                getDangerCoordinate: this.getDangerCoordinate,
                changeUserList: this.changeUserList,
                changeStatiMapHives: this.changeStatiMapHives,
                initUserList: this.initUserList,
            };
        },

        // 精准计算选中的人员和机库信息
        checkInfo () {
            // 过滤出真正勾选的机库
            let statiMapHives = this.statiMapHives.filter((item) => item.checked);
            // 过滤出真正勾选的人员
            let userCheckList = this.userCheckList.filter((item) => item.checked);

            // 校验：必须勾选至少一个人员/机库才能下发任务
            if (userCheckList.length === 0 && statiMapHives.length === 0) {
                this.$message.warning(this.$t('yingji.emergencyCase.selectAtLeastOne'));
                return null;
            }

            let obj = {
                dockId: '', // 机库ID列表，逗号分隔
                personnelId: '', // 人员ID列表，逗号分隔
                userSelect: this.userCheckList,
                checkedUsers: userCheckList, // 仅勾选的人员列表
            };

            // 处理机库信息
            statiMapHives.forEach((hive) => {
                obj.dockId = obj.dockId ? `${obj.dockId},${hive.dockId}` : hive.dockId;
            });

            // 处理人员信息（仅勾选的人员），收集teamId并去重
            const teamIds = [...new Set(userCheckList.filter((user) => user.teamId).map((user) => user.teamId))];
            obj.personnelId = teamIds.join(',');
            console.log('obj', obj);
            return obj;
        },

        // 新增：地图最低有效缩放层级（统一管控，避免低层级操作）
        minValidZoom () {
            return 10; // 可根据业务调整，低于该层级禁止视图强制操作
        },

        // 新增：目标默认缩放层级（确保事发点显示清晰）
        targetDefaultZoom () {
            return 13.5;
        },

    },
    data () {
        return {
            // 基础样式
            defaultStyle: {
                fill: {
                    color: '#49f0fd',
                },
                stroke: {
                    color: '#49f0fd',
                    width: 6,
                },
            },

            // 绘制相关
            activityObj: {},
            drawInfoList: [],
            innerCommandType: this.commandType,

            // 机库相关
            mapHives: [],
            statiMapHives: [], // 静态地图上的机库
            defaultCheckList: [], // 默认选中的机库
            dockListTimer: null, // 新增：机库列表刷新定时器实例

            // 案件和危险源相关
            caseListAll: [], // 全部案件
            dangerCoordinate: {}, // 事发点位置
            dangerObj: null,
            showCloseBtn: false,

            // 距离选择相关
            selectDistance: this.$t('yingji.emergencyCase.within3km'),
            selectDistanceList: [
                this.$t('yingji.emergencyCase.within3km'),
                this.$t('yingji.emergencyCase.within5km'),
                this.$t('yingji.emergencyCase.within10km'),
            ],

            // 人员相关
            userCheckList: [],
            caseId: null,

            // 新增案件弹窗相关
            addCaseDialogVisible: false,
            addCaseForm: {
                name: '',
                location: '',
            },
            pendingAddCaseParams: null, // 待添加的案件参数（包含坐标）
        };
    },
    watch: {
        // 监听Vuex状态变化
        layerAuto: {
            handler (newVal) { },
            immediate: true,
        },
        // 监听绘制类型变化
        commandType: {
            handler (newVal) {
                this.innerCommandType = newVal;
            },
            immediate: true,
            deep: true,
        },
        allCeseList: {
            handler (newVal) {
                this.caseListAll = newVal || [];
            },
            immediate: true,
            deep: true,
        },

        innerCommandType (newVal) {
        },

        // 监听statiMapHives变化，通知子组件刷新
        statiMapHives: {
            handler (newVal, oldVal) {
                console.log('[watch] statiMapHives 触发', '引用变化:', newVal !== oldVal);
                if (newVal !== oldVal) {
                    this.$nextTick(() => {
                        if (this.$refs.emergencyHives && typeof this.$refs.emergencyHives.refreshMapFeatures === 'function') {
                            this.$refs.emergencyHives.refreshMapFeatures();
                        }
                    });
                }
            },
        },

        // 监听危险坐标变化
        dangerCoordinate: {
            handler (newVal) {
                console.log('[watch] dangerCoordinate 触发', JSON.stringify(newVal));
                if (newVal && (newVal.longitude || newVal.latitude)) {
                    this.$nextTick(() => {
                        if (this.$refs.emergencyHives && typeof this.$refs.emergencyHives.refreshMapFeatures === 'function') {
                            this.$refs.emergencyHives.refreshMapFeatures();
                        }
                    });
                }
            },
        },

        // 监听距离选择变化，更新默认推荐列表
        selectDistance: {
            handler (newVal, oldVal) {
                console.log('[watch] selectDistance 触发', newVal, '===old:', oldVal, 'dangerObj:', !!this.dangerObj);
                if (this.dangerObj && newVal !== oldVal) {
                    this.setDefaultCheckList();
                }
            },
        },

        // 监听dangerObj变化，通知父组件
        dangerObj: {
            handler (newVal) {
                console.log('[watch] dangerObj 触发', newVal ? newVal.id : null);
                this.$emit('update:dangerObj', newVal);
            },
        },
    },
    methods: {
        // ===================== 初始化相关 =====================
        async init () {
            // 获取地图实例
            const map = await this.getMap();
            this.$map = map;
            let gridInfoShow = this.$props.gridId !== '';
            // 网格详情地图禁用交互事件
            gridInfoShow && this.setMapDisable();

            // 可选：如果需要等待LayerAuto加载完成后再执行某些逻辑
            this.waitForLayerAutoLoaded();
        },

        // 等待LayerAuto加载完成的辅助方法
        async waitForLayerAutoLoaded () {
            // 轮询检查LayerAuto是否加载完成，最多等待10秒
            const maxAttempts = 20; // 20 * 500ms = 10秒
            let attempts = 0;

            return new Promise((resolve) => {
                const checkLayerAuto = () => {
                    attempts++;
                    const layerAuto = this.$store.state.Common?.LayerAuto;

                    if (layerAuto && Object.keys(layerAuto).length > 0) {
                        resolve(layerAuto);
                    } else if (attempts < maxAttempts) {
                        setTimeout(checkLayerAuto, 500);
                    } else {
                        resolve({});
                    }
                };

                checkLayerAuto();
            });
        },

        // 初始化机库列表（新增20秒定时刷新）
        initDockList () {
            // 定义核心的获取机库列表逻辑（提取为内部函数，方便重复调用）
            const fetchDockList = () => {
                IndexApi.getDockList().then((res) => {
                    if (res.code === 200) {
                        this.mapHives = res.data || [];
                        // 关键修复：初始化时给每个机库添加响应式的hasCheckedBox属性
                        this.statiMapHives = (res.data || []).map((item) => ({
                            ...item,
                            checked: false,
                            hasCheckedBox: false,
                            distance: '',
                        }));
                        // console.log('机库列表刷新完成:', this.statiMapHives);
                    }
                }).catch((error) => {
                    // console.error('获取机库列表失败:', error);
                });
            };

            // 1. 立即执行一次（保持原有初始化逻辑）
            fetchDockList();

            // 2. 清除已有定时器（防止重复创建）
            if (this.dockListTimer) {
                clearInterval(this.dockListTimer);
            }

            // 3. 创建新定时器，每20秒刷新一次（20000毫秒 = 20秒）
            this.dockListTimer = setInterval(() => {
                fetchDockList();
            }, 20000);
        },

        // ===================== 地图交互相关 =====================
        // 地图转到屏幕中央（优化：低层级防护+分步缩放）
        async getCenterView (center, targetZoom = null) {
            console.log('[getCenterView] 开始', { center, targetZoom });
            if (!this.$map || !Array.isArray(center) || center.length < 2) return;

            try {
                const view = this.$map.getView();
                const currentZoom = view.getZoom() || this.minValidZoom;
                const finalZoom = targetZoom || this.targetDefaultZoom;

                // // 第二步：平滑定位到目标中心，限制最大缩放层级
                // view.fit(center, {
                //     padding: [50, 50, 50, 50],
                //     maxZoom: finalZoom,
                //     duration: 1000,
                // });

                // // 第三步：确保最终缩放层级正确，避免fit方法未达标
                await new Promise((resolve) => setTimeout(resolve, 800));
                if (view.getZoom() < finalZoom) {
                    view.setZoom(finalZoom);
                }
                view.animate({
                    center,
                    duration: 1000,
                });

                // // 强制刷新地图渲染
                this.$map.render();
            } catch (error) {
                console.error('地图定位失败:', error);
                this.resetMapView();
            }
        },

        // 禁用地图交互
        async setMapDisable () {
            if (!this.$map) return;

            const zoomInteractions = this.$map
                .getInteractions()
                .getArray()
                .filter(
                    (interaction) =>
                        interaction instanceof PinchZoom
                        || interaction instanceof MouseWheelZoom
                        || interaction instanceof DoubleClickZoom
                        || interaction instanceof DragPan,
                );

            // 补充：实际禁用交互的逻辑
            zoomInteractions.forEach((interaction) => {
                interaction.setActive(false);
            });
        },

        // 处理要素选择
        handleSelectFeature (feature) {
            const values = feature.getProperties();
            let id = feature.getId();
            let refs = {};

            if (values.name === 'event') {
                refs = this.$refs[values.id];
                this.getRefs(refs);
            } else if (id) {
                refs = this.$refs[id];
                this.getRefs(refs);
            }
        },

        // 显示地图弹窗
        getRefs (refs) {
            let refEl = null;
            if (Array.isArray(refs)) {
                refEl = refs[0];
            } else {
                refEl = refs;
            }
            if (refEl) {
                this.activityObj = refEl.layerData;
                refEl.showPopover();
            }
        },

        // ===================== 机库相关 =====================
        // 父组件（OpenlayerYingJiLayer.vue）中的 changeStatiMapHives 方法
        changeStatiMapHives (checked, obj, hasCheckedBox, list) {
            // console.log('[changeStatiMapHives] 调用', { checked, objId: obj?.id, hasCheckedBox, listLen: list?.length });

            if (list) {
                this.defaultCheckList = list;
                this.statiMapHives.forEach((item) => {
                    this.$set(item, 'checked', false);
                    list.forEach((i) => {
                        if (i.id === item.id) {
                            this.$set(item, 'checked', checked);
                            this.$set(item, 'hasCheckedBox', true); // 强制设置hasCheckedBox
                        }
                    });
                });
            } else if (obj && hasCheckedBox !== undefined) {
                // 重点：更新 hasCheckedBox 时使用 $set 确保响应式
                const targetItem = this.statiMapHives.find((item) => item.id === obj.id);
                if (targetItem) {
                    this.$set(targetItem, 'checked', checked);
                    this.$set(targetItem, 'hasCheckedBox', hasCheckedBox);
                }
            } else if (!checked && !obj && !hasCheckedBox && !list) {
                this.statiMapHives.forEach((item) => {
                    this.$set(item, 'checked', false);
                    this.$set(item, 'hasCheckedBox', false);
                });
            } else {
                // 关键修复：处理只有checked和obj的情况（距离筛选时）
                // eslint-disable-next-line no-lonely-if
                if (obj && hasCheckedBox === undefined) {
                    const targetItem = this.statiMapHives.find((item) => item.id === obj.id);
                    if (targetItem) {
                        this.$set(targetItem, 'checked', checked);
                        this.$set(targetItem, 'hasCheckedBox', checked);
                    }
                }
            }
        },

        // ===================== 距离选择相关 =====================
        // 设置默认推荐列表：合并选中的人员和机库，按距离排序，只保留最近的一个推荐
        setDefaultCheckList () {
            if (!this.dangerObj) return;
            console.log('[setDefaultCheckList] 开始');
            let statiMapHives = this.statiMapHives.filter((item) => item.hasCheckedBox && item.distance);
            let userCheckedList = this.userCheckList.filter((item) => item.checked && item.distance);
            this.defaultCheckList = [...userCheckedList, ...statiMapHives];
            this.defaultCheckList.forEach((item) => {
                if (item.distance.includes('km')) {
                    item.sortKm = item.distance.split('km')[0];
                } else if (!item.distance.includes('km')) {
                    item.sortKm = item.distance.split('m')[0] / 1000;
                }
            });
            this.defaultCheckList.sort((a, b) => a.sortKm - b.sortKm);
            this.defaultCheckList = this.defaultCheckList.slice(0, 1);
            this.changeStatiMapHives(true, null, true, this.defaultCheckList);
        },

        // 距离选择逻辑（优化：低层级防护+分步更新）
        selectDistanceFn (distance) {
            console.log('[selectDistanceFn] 调用', distance);
            const currentZoom = this.$refs.emergencyPersonnel?.mapZoom || this.minValidZoom;
            if (currentZoom < this.minValidZoom) {
                console.warn('地图层级过低，跳过距离筛选');
                return;
            }

            this.selectDistance = distance;
            this.changeUserList(null, distance);

            // 机库距离筛选逻辑（分步执行，减轻地图压力）
            setTimeout(() => {
                let curDistance = parseInt(distance, 10);
                // console.log('距离筛选:', { curDistance, dangerCoordinate: this.dangerCoordinate });

                // 校验危险坐标有效性
                if (!this.dangerCoordinate?.longitude || !this.dangerCoordinate?.latitude) {
                    console.warn('危险坐标无效，跳过机库筛选');
                    return;
                }

                this.statiMapHives.forEach((hive) => {
                    if (hive.longitude && hive.latitude) {
                        let num = getDistance(
                            { latitude: +hive.latitude, longitude: +hive.longitude },
                            { latitude: +this.dangerCoordinate.latitude, longitude: +this.dangerCoordinate.longitude },
                        );
                        this.$set(hive, 'distance', num);

                        let isInRange = false;
                        // 修复距离判断逻辑
                        if (num.includes('km')) {
                            const kmValue = parseFloat(num);
                            isInRange = kmValue < curDistance;
                        } else {
                            const mValue = parseFloat(num);
                            isInRange = mValue < curDistance * 1000;
                        }

                        // console.log(`机库${hive.id}距离:${num}, 是否在${curDistance}km内:`, isInRange);
                        // 关键修复：传递完整参数，包括hasCheckedBox
                        this.changeStatiMapHives(isInRange, hive, isInRange);
                    }
                });

                // 筛选完成后，刷新地图要素
                this.$nextTick(() => {
                    if (this.$refs.emergencyHives && typeof this.$refs.emergencyHives.refreshMapFeatures === 'function') {
                        this.$refs.emergencyHives.refreshMapFeatures();
                    }
                });
            }, 200);
        },

        // 可选：添加降级处理方法（当子组件方法不存在时）
        handleDefaultCheckListFallback (distance) {
            // 低层级防护
            const currentZoom = this.$refs.emergencyPersonnel?.mapZoom || this.minValidZoom;
            if (currentZoom < this.minValidZoom) return;

            const curDistance = parseInt(distance, 10);
            // 遍历用户列表，自动勾选指定距离内的人员
            this.userList.forEach((item) => {
                if (item.info) {
                    item.info.forEach((uitem) => {
                        if (
                            uitem.distance
                            && parseInt(
                                uitem.distance.includes('km')
                                    ? uitem.distance
                                    : parseInt(uitem.distance, 10) / 1000,
                                10,
                            ) < curDistance
                        ) {
                            this.$set(uitem, 'checked', true);
                        }
                    });
                } else if (
                    item.distance
                    && parseInt(
                        item.distance.includes('km') ? item.distance : parseInt(item.distance, 10) / 1000,
                        10,
                    ) < curDistance
                ) {
                    this.$set(item, 'checked', true);
                }
            });
        },

        // 补充缺失的clusterMarkers方法（避免报错）
        clusterMarkers (arr, scale) {
            // 这里补充你的聚合逻辑，示例返回空数组避免报错
            console.warn('clusterMarkers方法未实现，需要补充聚合逻辑');
            return [];
        },

        changeUserList (map, distance) {
            if (!map && !distance) {
                this.userList.forEach((item) => {
                    item.checked = false;
                });
            }
            if (map) {
                let resolution = map.getView().getResolution();
                let inchesPerMeter = 39.37;
                let dpi = 96;
                let width = map.getSize()[0] * resolution;
                let scale = ((width / inchesPerMeter) * dpi) / 0.0254;
                let userList = [];
                if (this.userList.length > 0) {
                    let arr = [];
                    this.userList.forEach((item) => {
                        if (item.info) {
                            arr.push(...item.info);
                        } else {
                            arr.push(item);
                        }
                    });
                    userList = this.clusterMarkers(arr, scale);
                } else {
                    userList = this.clusterMarkers(this.initUserListArr, scale);
                }
                let list = [];
                userList.forEach((item, index) => {
                    let obj = {};
                    if (item.markers.length > 1) {
                        let clusterPositonList = item.markers.map((pos) => [+pos.longitude, +pos.latitude]);
                        // 补充getPointsCenter方法（避免报错）
                        let center = getPointsCenter(clusterPositonList);
                        obj.longitude = center.longitude;
                        obj.latitude = center.latitude;
                        obj.text = this.$t('yingji.openlayer.totalPerson', { count: item.markers.length });
                        obj.info = item.markers;

                        this.$nextTick(() => {
                            this.$set(obj, 'point', item.markers[0].point);
                            this.$set(obj, 'distance', item.markers[0].distance);
                            this.$set(obj, 'duration', item.markers[0].duration);
                            this.$set(obj, 'km_latitude', item.markers[0].km_latitude);
                            this.$set(obj, 'km_longitude', item.markers[0].km_longitude);

                            let hasObj = item.markers.find((p) => p.hasCheckedBox);
                            if (hasObj) {
                                this.$set(obj, 'hasCheckedBox', true);
                            } else {
                                this.$set(obj, 'hasCheckedBox', false);
                            }
                        });

                        obj.teamNum = item.markers[0].teamNum;
                        obj.personnelStatus = item.markers[0].personnelStatus;
                        obj.personnelId = (Math.random(index + 1) * 10).toString();
                        obj.id = `cluster_${index}_${Date.now()}`;
                    } else {
                        obj = item.markers[0];
                    }
                    list.push(obj);
                });
                this.$nextTick(() => {
                    this.userList = list;
                });
            }

            // 公里范围设置复选框是否存在
            if (distance) {
                // 低层级防护：低于最低有效层级，跳过距离更新
                const currentZoom = this.$refs.emergencyPersonnel?.mapZoom || this.minValidZoom;
                if (currentZoom < this.minValidZoom) return;

                let curDistance = parseInt(distance, 10);
                this.userList.forEach((item) => {
                    if (item.info) {
                        item.info.forEach((uitem) => {
                            if (
                                uitem.distance
                                && parseInt(
                                    uitem.distance.includes('km')
                                        ? uitem.distance
                                        : parseInt(uitem.distance, 10) / 1000,
                                    10,
                                ) < curDistance
                            ) {
                                this.$set(uitem, 'hasCheckedBox', true);
                            } else {
                                this.$set(uitem, 'hasCheckedBox', false);
                            }
                        });
                    }
                    if (
                        item.distance
                        && parseInt(
                            item.distance.includes('km') ? item.distance : parseInt(item.distance, 10) / 1000,
                            10,
                        ) < curDistance
                    ) {
                        this.$set(item, 'hasCheckedBox', true);
                    } else {
                        this.$set(item, 'hasCheckedBox', false);
                    }
                });
            }
        },

        // ===================== 绘制相关 =====================
        // 添加数据事件
        handleAddDataEvent (params, type) {
            // console.log('allCeseList', this.allCeseList);

            if (type === 'case') {
                this.pendingAddCaseParams = params;
                this.addCaseForm = {
                    name: '',
                    location: '',
                };
                this.addCaseDialogVisible = true;
            } else if (type === 'canvas') {
                let obj = {
                    ...params,
                    caseId: this.activityCase.id || '',
                };
                // console.log('handleAddDataEvent', obj);
                this.handleAddCanvas(obj);
            }
            this.innerCommandType = '';
        },

        // 删除数据事件
        async handleDeleteDataEvent (id, type) {
            if (type === 'case') {
                try {
                    const res = await IndexApi.delCase(id);
                    if (res.code === 200) {
                        this.$message.success(this.$t('yingji.emergencyCase.deleteSuccess'));
                        this.getCaseList();
                    } else {
                        this.$message.error(res.msg || this.$t('yingji.emergencyCase.deleteFailed'));
                    }
                } catch (err) {
                    console.error('delCase error:', err);
                    this.$message.error(this.$t('yingji.emergencyCase.deleteFailedRetry'));
                }
            }
        },

        getCaseList () {
            this.$emit('bindCaseList');
        },

        // 新增画布资源
        async handleAddCanvas (params) {
            await IndexApi.addResourceCanvas({ ...params }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(this.$t('yingji.emergencyCase.createSuccess'));
                    this.getCaseList();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 确认新增案件
        async handleConfirmAddCase (params) {
            this.addCaseDialogVisible = false;
            this.pendingAddCaseParams = null;
            this.getCaseList();
            this.$emit('resetEmergencyFlyType');
        },

        // 取消新增案件
        handleCancelAddCase () {
            if (this.pendingAddCaseParams && this.pendingAddCaseParams.type) {
                this.innerCommandType = this.pendingAddCaseParams.type;
            }
            this.addCaseDialogVisible = false;
            this.pendingAddCaseParams = null;
            this.$emit('resetEmergencyFlyType');
        },

        // 新增案件
        async handleAddCase (params) {
            await IndexApi.addCase({ ...params }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(this.$t('yingji.emergencyCase.createCaseSuccess'));
                    this.getCaseList();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 获取今日的绘制图案
        async getDrawInfoListInToday () {
            // 原有逻辑保留
        },

        // ===================== 事发点相关 =====================
        // 获取事发点位置
        getDangerCoordinate (obj) {
            this.dangerCoordinate = {
                latitude: obj ? obj.latitude : '',
                longitude: obj ? obj.longitude : '',
            };
        },

        // 核心修复：showRoute 方法（低层级防护+分步执行+异常兜底）
        async showRoute (id, obj) {
            console.log('[showRoute] 开始 ====', { id, objId: obj?.id, currentDangerObjId: this.dangerObj?.id });

            // 第一步：重置逻辑（无id时），平稳清空状态，避免地图闪崩
            if ((this.dangerObj && this.dangerObj.id === id) || !id) {
                console.log('[showRoute] 进入重置分支');
                this.getDangerCoordinate(null);
                this.dangerCoordinate = { latitude: '', longitude: '' };
                this.dangerObj = null;

                setTimeout(() => this.changeUserList(), 100);
                setTimeout(() => this.changeStatiMapHives(), 200);

                this.$nextTick(() => {
                    if (this.$map) this.$map.render();
                });
                console.log('[showRoute] 重置完成，return');
                return;
            }

            console.log('[showRoute] 进入设置分支');

            // 第二步：校验参数有效性
            if (!obj || !obj.longitude || !obj.latitude) {
                console.warn('[showRoute] 事发点参数无效');
            }

            // 第三步：低层级防护
            const personnelComponent = this.$refs.emergencyPersonnel;
            const currentZoom = personnelComponent?.mapZoom || this.minValidZoom;
            const needZoomUpgrade = currentZoom < this.targetDefaultZoom;
            console.log('[showRoute] 缩放层级', { currentZoom, needZoomUpgrade });

            // 第四步：设置事发点状态
            this.dangerObj = { ...obj };
            this.caseId = obj.id;
            this.dangerCoordinate = { latitude: obj.latitude, longitude: obj.longitude };
            console.log('[showRoute] dangerObj/dangerCoordinate 已设置');

            // 第五步：地图视图定位
            if (needZoomUpgrade) {
                console.log('[showRoute] 开始地图定位...');
                await this.getCenterView([obj.longitude, obj.latitude], this.targetDefaultZoom);
                console.log('[showRoute] 地图定位完成');
            }

            // 第六步：批量计算人员距离
            if (this.userList.length > 0) {
                console.log('[showRoute] 开始计算人员距离, userList.length:', this.userList.length);
                const batchSize = 10;
                const userListCopy = [...this.userList];

                for (let i = 0; i < userListCopy.length; i += batchSize) {
                    const batch = userListCopy.slice(i, i + batchSize);
                    // eslint-disable-next-line no-await-in-loop
                    await this.calcUserDistanceBatch(batch, personnelComponent);
                    // eslint-disable-next-line no-await-in-loop
                    await new Promise((resolve) => setTimeout(resolve, 100));
                }
                console.log('[showRoute] 人员距离计算完成');
            }

            // 第七步：延迟执行距离筛选
            console.log('[showRoute] 延迟800ms后执行 selectDistanceFn');
            setTimeout(() => {
                console.log('[showRoute] 开始执行 selectDistanceFn');
                this.selectDistanceFn('3km内');
                console.log('[showRoute] selectDistanceFn 执行完毕');
            }, 800);
            console.log('[showRoute] showRoute 结束 ====');
        },

        // 新增：分片计算人员距离，减轻地图压力
        async calcUserDistanceBatch (batch, personnelComponent) {
            console.log('[calcUserDistanceBatch] 批次大小:', batch.length);
            // eslint-disable-next-line no-restricted-syntax
            for (const item of batch) {
                try {
                    // 优先调用子组件方法
                    if (personnelComponent && typeof personnelComponent.calcdistanceAndTime === 'function') {
                        if (item.longitude && item.latitude) {
                            // eslint-disable-next-line no-await-in-loop
                            await personnelComponent.calcdistanceAndTime(item);
                        }
                    } else {
                        // 降级计算，避免方法不存在时报错
                        this.calcUserDistanceFallback(item);
                    }
                } catch (error) {
                    console.warn('计算单个人员距离失败:', error);
                    this.calcUserDistanceFallback(item);
                }
            }
        },

        // 新增：人员距离计算降级方案
        calcUserDistanceFallback (item) {
            if (!this.dangerCoordinate?.longitude || !this.dangerCoordinate?.latitude) return;

            let distance = getDistance(
                { longitude: item.longitude, latitude: item.latitude },
                {
                    longitude: this.dangerCoordinate.longitude,
                    latitude: this.dangerCoordinate.latitude,
                },
            );

            // 格式化距离
            if (distance / 1000 >= 1) {
                distance = `${(distance / 1000).toFixed(1)}km`;
            } else {
                distance = `${distance}m`;
            }

            // 响应式更新，避免直接修改引发异常
            this.$set(item, 'point', [
                [item.longitude, item.latitude],
                [this.dangerCoordinate.longitude, this.dangerCoordinate.latitude],
            ]);
            this.$set(item, 'distance', distance);
            this.$set(item, 'duration', '--');
            this.$set(
                item,
                'km_latitude',
                (+item.latitude + +this.dangerCoordinate.latitude) / 2,
            );
            this.$set(
                item,
                'km_longitude',
                (+item.longitude + +this.dangerCoordinate.longitude) / 2,
            );
        },

        // ===================== 任务下发相关 =====================
        // 高度判断（修复多边形坐标问题）
        heightJudge (arr, poylonList) {
            let flagArr = [];
            // 补充多边形坐标闭合处理
            const closePolygonRing = (coords) => {
                if (!Array.isArray(coords) || coords.length === 0) return [[[0, 0], [0, 1], [1, 1], [1, 0], [0, 0]]];
                let ring = coords[0] || coords;
                if (!Array.isArray(ring)) return [[[0, 0], [0, 1], [1, 1], [1, 0], [0, 0]]];

                // 确保至少3个点
                if (ring.length < 3) return [[[0, 0], [0, 1], [1, 1], [1, 0], [0, 0]]];

                // 闭合坐标环
                const first = ring[0];
                const last = ring[ring.length - 1];
                if (first[0] !== last[0] || first[1] !== last[1]) {
                    ring = [...ring, first];
                }
                return [ring];
            };

            poylonList.forEach((poylon) => {
                try {
                    let closedArr = closePolygonRing(arr);
                    let poly1 = turf.polygon(closedArr);

                    if (!poylon.coordinates || poylon.coordinates.length === 0) {
                        console.warn('无效的多边形坐标:', poylon);
                        return;
                    }

                    let closedPoylonCoords = closePolygonRing([poylon.coordinates]);
                    let poly2 = turf.polygon(closedPoylonCoords);

                    let status = turf.booleanOverlap(poly1, poly2);
                    if (status) {
                        flagArr.push(Number(poylon.height || 0));
                    }
                } catch (e) {
                    console.error('多边形构造失败:', e, poylon);
                }
            });
            return flagArr;
        },

        // 获取航线距离
        getRouteDistance (points) {
            let sum = 0;
            // 增加参数校验
            if (!Array.isArray(points) || points.length < 2) return 0;

            points.forEach((item, i) => {
                if (i > 0) {
                    let point1 = points[i - 1];
                    let point2 = points[i];
                    let p1 = { lat: point1.latitude, lng: point1.longitude };
                    let p2 = { lat: point2.latitude, lng: point2.longitude };
                    let d = Utils.getDistance(p1.lat, p1.lng, p2.lat, p2.lng);
                    sum += d;
                }
            });
            return (sum / 1000).toFixed(2);
        },

        // 获取预计飞行时间
        getEstimateTime (points) {
            let second = 0;
            // 增加参数校验
            if (!Array.isArray(points) || points.length < 2) return 0;

            points.forEach((item, i) => {
                if (i > 0) {
                    let point1 = points[i - 1];
                    let point2 = points[i];
                    let p1 = { lat: Number(point1.latitude), lng: Number(point1.longitude) };
                    let p2 = { lat: Number(point2.latitude), lng: Number(point2.longitude) };
                    let d = Utils.getDistance(p1.lat, p1.lng, p2.lat, p2.lng);
                    second += d / Number(15);
                }
            });
            return (Number(second) / 60).toFixed(2);
        },

        // 创建群聊
        createChatGroup (personList, groupName) {
            if (personList.length >= 2) {
                let formData = {
                    groupName,
                    memberIds: '',
                    memberNames: '',
                };
                let nameList = [];
                let idList = [];
                let dataList = personList;

                dataList.forEach((item) => {
                    let name = item.name || item.personnelName;
                    nameList.push(name);
                    idList.push(item.account);
                });

                formData.memberIds = idList.join();
                formData.memberNames = nameList.join();

                if (this.userInfo) {
                    let account = this.userInfo.account;
                    let uname = this.userInfo.name;
                    formData.memberIds = `${account},${formData.memberIds}`;
                    formData.memberNames = `${uname},${formData.memberNames}`;
                }

                if (this.$root.$imManager) {
                    this.$root.$imManager.createChatGroup(formData).then(() => {
                        if (this.$root.$imManager._vm) {
                            this.$root.$imManager._vm.show = true;
                            this.$nextTick(() => {
                                const windowInnerWidth = window.innerWidth;
                                const windowInnerHeight = window.innerHeight;
                                const chatMainElement = this.$root.$imManager._vm.$el;
                                const clientHeight = chatMainElement.clientHeight;
                                const clientWidth = chatMainElement.clientWidth;
                                let moveLeft = windowInnerWidth / 2 - clientWidth - 16;
                                let moveTop = windowInnerHeight / 2 - clientHeight - 16;
                                this.$root.$imManager._vm.moveLeft = moveLeft;
                                this.$root.$imManager._vm.moveTop = moveTop;
                            });
                        }
                    });
                }
            }
        },

        // 一键下发任务
        async handleSendCommand () {
            // 1. 基础校验：必须选择事发点
            if (!this.dangerObj) {
                this.$message.warning(this.$t('yingji.emergencyCase.selectDangerPointFirst'));
                return;
            }

            // 2. 获取勾选的人员/机库信息
            const checkInfo = this.checkInfo;

            if (!checkInfo) {
                return;
            }

            // 3. 校验人员或机库至少选中一项
            const hasSelectedPerson = checkInfo.checkedUsers && checkInfo.checkedUsers.length > 0;
            const hasSelectedDock = checkInfo.dockId && checkInfo.dockId.length > 0;
            if (!hasSelectedPerson && !hasSelectedDock) {
                this.$message.warning(this.$t('yingji.emergencyCase.selectAtLeastOne'));
                return;
            }

            let { longitude, latitude } = this.dangerObj;

            // 4. 构造请求参数
            let params = {
                caseId: this.caseId,
                longitude,
                latitude,
                dockIds: checkInfo.dockId || '',
                teamIds: checkInfo.personnelId || '',
            };
            console.log('params', params);

            // 5. 下发任务（保留原有注释，按需启用）
            await IndexApi.AddDispactTask(params).then((res) => {
                if (res.code === 200) {
                    this.$message.success(this.$t('yingji.emergencyCase.dispatchSuccess'));
                }
            });

            // 6. 保存小组与案件关联
            // if (checkInfo.checkedUsers.length > 0) {
            //     const savePromises = checkInfo.checkedUsers.map(async (item) => {
            //         let obj = { caseId: this.caseId, teamId: item.teamId };
            //         return await IndexApi.saveCaseTeam(obj).run();
            //     });
            //     await Promise.all(savePromises);
            // }

            // 7. 创建群聊
            // if (checkInfo.checkedUsers.length >= 2) {
            //     this.createChatGroup(checkInfo.checkedUsers, `事发点沟通群(${this.dangerObj.name})`);
            // } else if (checkInfo.checkedUsers.length === 1) {
            //     this.$message.info('仅选择1名人员，无需创建群聊');
            // }

            // 8. 重置状态
            this.showRoute(null);
            this.initUserList();
        },

        // ===================== 兜底方法：重置地图视图 =====================
        async resetMapView () {
            try {
                if (!this.$map) {
                    this.$map = await this.getMap();
                    if (!this.$map) return;
                }

                const view = this.$map.getView();
                const currentCenter = view.getCenter() || [0, 0];
                const currentZoom = view.getZoom() || this.minValidZoom;

                // 分步重置，避免一次性操作引发崩溃
                view.setZoom(this.minValidZoom);
                await new Promise((resolve) => setTimeout(resolve, 300));

                view.setCenter(currentCenter);
                await new Promise((resolve) => setTimeout(resolve, 300));

                view.setZoom(Math.max(currentZoom, this.minValidZoom));
                this.$map.render();

                // console.log('地图视图已重置，避免空白');
            } catch (error) {
                console.error('重置地图视图失败:', error);
            }
        },
    },
    mounted () {
        this.init();
        this.initDockList();
    },
    // 新增：组件销毁时清除定时器，防止内存泄漏
    beforeDestroy () {
        if (this.dockListTimer) {
            clearInterval(this.dockListTimer);
            this.dockListTimer = null;
            // console.log('机库列表刷新定时器已清除');
        }
    },
};
</script>

<style lang="scss" scoped>
// 全局样式
.dialog-main {
    padding-top: 20vh;

    ::v-deep.el-dialog {
        background: #071150;
        color: white;
        box-shadow: inset 0px 0px 10px 0px #49f0fd;
        opacity: 1;
        border: 1px solid #49f0fd;
        border-radius: 4px;
    }

    ::v-deep.el-dialog__header {
        padding: 16px;
        border-bottom: #49f0fd 1px solid;
        box-shadow: inset 0px -1px 5px #49f0fd;
    }

    .dialog-title {
        text-align: left;
        position: relative;
        width: 100%;
        height: 20px;
        line-height: 20px;
        color: #49f0fd;

        .icon-close {
            position: absolute;
            right: -38px;
            top: -37px;
            width: 41px;
            height: 41px;
        }
    }

    .form-item {
        margin-bottom: 20px;

        ::v-deep.el-form-item__label {
            color: white;
        }

        ::v-deep.el-form-item__content {
            height: 36px;
        }

        .color-picker {
            width: 270px;
            overflow: hidden;
        }

        .cell-hangar {
            width: 100%;
        }

        .type-cell {
            text-align: center;
            width: 34px;
            height: 34px;
            border-radius: 2px 2px 2px 2px;
        }

        .bg-1 {
            background: rgba(7, 17, 80, 0.7);
            border: 1px solid rgba(7, 17, 80, 0.7);
        }

        .bg-2 {
            background: rgba(73, 240, 253, 0.2);
            border-radius: 1px 1px 1px 1px;
            border: 1px solid #49f0fd;
        }

        .type-img {
            width: 24px;
            height: 24px;
            margin: 5px 0;
        }

        .route-default {
            border-radius: 2px 2px 2px 2px;
            background: #071150;
            border: 1px solid rgba(46, 125, 248, 0.4);
            color: white;
        }

        .route-activity {
            box-shadow: inset 0px 0px 10px 0px #49f0fd;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #49f0fd;
            color: #49f0fd;
        }
    }

    .btn {
        width: 144px;
        font-size: 14px;
    }

    .btn-close {
        color: #49f0fd;
        border: 1px solid #49f0fd;
        background: rgba(73, 240, 253, 0.2);
    }

    .btn-define {
        color: #000000;
        background: #49f0fd;
        border: 1px solid #49f0fd;
    }

    .mar-bottom-0 {
        margin-bottom: 0px;
    }

    .display-flex {
        display: flex;
    }

    .flex-start {
        justify-content: flex-start;
    }

    .space-between {
        justify-content: space-between;
    }
}

// 一键下发按钮样式
.command-btn {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 158px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: #000;
    cursor: pointer;
    background: url('./images/command-btn-bg.png');
}

// 距离选择样式
.select-distance {
    position: absolute;
    top: 65px;
    right: 20px;
    text-align: center;
    line-height: 32px;
    color: #fff;

    .select-distance-item {
        width: 90px;
        height: 32px;
        cursor: pointer;
        margin-bottom: 10px;
        background: url('./images/select-distance-bg.png');

        &.active,
        &:hover {
            background: url('./images/select-distance-bg-active.png');
            color: #000000;
        }
    }
}

// 机库相关样式
::v-deep .command-overlayer-hives-checkbox {
    z-index: 3;
}

::v-deep .command-overlayer-hives-km {
    z-index: 4;
}

::v-deep .el-checkbox__inner {
    width: 16px;
    height: 16px;
    background: transparent;
    border: 2px solid #49f0fd;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: #49f0fd;
    border-color: #49f0fd;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #49f0fd;
}

::v-deep .el-checkbox__inner::after {
    left: 4px;
    top: 1px;
    border-color: #000;
}

::v-deep .point-distance {
    font-size: 14px;
    color: #fff;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: rgba(7, 17, 80, 0.7);
    box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #49f0fd;
    padding: 0 5px;
}

::v-deep .point-distance-active {
    height: 22px;
    line-height: 22px;
    padding: 0 5px;
    text-align: center;
    font-size: 14px;
    color: #10163a;
    background: linear-gradient(90deg, #ff8b00 0%, rgba(255, 214, 0, 0.94) 100%);
    border-radius: 2px 2px 2px 2px;
    border: 1px solid rgba(7, 17, 80, 0.7);
}
</style>
